module.exports = __webpack_public_path__ + "static/media/tractorPlow_white.d0c6a889.svg";